<div style="display: flex; flex-direction: column; height: 100%; width: 100%; overflow: hidden;" data-cy="fee-schedule-list-container">
  <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="fee-schedule-list-spinner"></app-tdo-progress-spinner>

  <div *ngIf="!isLoading" data-cy="fee-schedule-list-content">

    <button mat-button style="margin-left: 10px;" class="tdo-button tdo-save"
    (click)="onNewFeeSchedule()" data-cy="fee-schedule-list-new-button">New</button>

    <dx-scroll-view height="800" data-cy="fee-schedule-list-scroll-view">
      <dx-accordion id="listFeeScheds" [dataSource]="feeScheduleList" [collapsible]="true" [multiple]="false"
        [animationDuration]="300" (onItemClick)="onFeeScedItemClick($event)"
        (onContentReady)="onAccordionReady($event)" data-cy="fee-schedule-list-accordion">

        <div *dxTemplate="let feesch of 'title'" data-cy="fee-schedule-list-title-template">
          <div style="color: var(--tdo-primary)" (contextmenu)="onFeeSchedRightClick($event, feesch)" data-cy="fee-schedule-list-title-item">{{
            feesch.FeeScheduleName }}</div>
        </div>

        <div *dxTemplate="let feeschi of 'item'" data-cy="fee-schedule-list-item-template">
          <dx-list [dataSource]="feeschi.dataFeeScheduleDoctors" (onItemClick)="onDocFeeClick($event);" data-cy="fee-schedule-list-doctor-list">
            <div *dxTemplate="let item of 'item'" data-cy="fee-schedule-list-doctor-template">
              <div (contextmenu)="onFeeSchedRightClick($event, item)" data-cy="fee-schedule-list-doctor-item">
                <div style="float: left;" data-cy="fee-schedule-list-doctor-name">{{item.Description}} </div>
                <div style="float: right; text-align: right;" *ngIf="item.isActive" data-cy="fee-schedule-list-doctor-active">Active</div>
              </div>
            </div>
          </dx-list>
        </div>
      </dx-accordion>
    </dx-scroll-view>
    <dx-context-menu #contextMenu [target]="'#listFeeScheds'" [items]="contextMenuItems"
      (onItemClick)="onContextMenuFeeSchedItemClick($event)" data-cy="fee-schedule-list-context-menu">
    </dx-context-menu>
  </div>
</div>